import Image from "next/image.js";
import {
  FacebookEmbed,
  InstagramEmbed,
  LinkedInEmbed,
  TikTokEmbed,
  XEmbed,
  YouTubeEmbed,
} from "react-social-media-embed";
import VideoBlockViewClientside from "../VideoBlock/components/VideoBlockViewClientside.js";
import { SocialMediaEmbedServerside } from "../SocialMedia/SocialMediaEmbedServerside.js";
import InsideLinksComponent from "../InsideLinks/InsideLinksComponent.js";
import { ImageBlockViewClientside } from "../ImageBlock/components/ImageBlockViewClientside.js";

function checkIfValidLink(link: string) {
  return typeof link === "string";
}
export const renderEmbedContent = (content, getVideoAspect) => {
  switch (content.type) {
    case "twitter":
      if (!checkIfValidLink(content.attrs.url)) {
        return null;
      }
      return (
        <SocialMediaEmbedServerside>
          <XEmbed url={content.attrs.url || ""} width={325} />
        </SocialMediaEmbedServerside>
      );
    case "youtube":
      if (!checkIfValidLink(content.attrs.url)) {
        return null;
      }
      return (
        <SocialMediaEmbedServerside>
          <YouTubeEmbed url={content.attrs.url || ""} />
        </SocialMediaEmbedServerside>
      );
    case "instagram":
      if (!checkIfValidLink(content.attrs.url)) {
        return null;
      }
      return (
        <SocialMediaEmbedServerside>
          <InstagramEmbed
            className="max-w-[328px]"
            url={content.attrs.url || ""}
            width={328}
            captioned
          />
        </SocialMediaEmbedServerside>
      );
    case "tiktok":
      if (!checkIfValidLink(content.attrs.url)) {
        return null;
      }
      return (
        <SocialMediaEmbedServerside>
          <TikTokEmbed
            className="max-w-[328px]"
            url={content.attrs.url || ""}
            width={328}
          />
        </SocialMediaEmbedServerside>
      );
    case "imageBlock":
      return <ImageBlockViewClientside content={content} />;
    case "videoBlock":
      // @ts-ignore
      return (
        <VideoBlockViewClientside
          node={content}
          getVideoAspect={getVideoAspect}
        />
      );
    case "facebook":
      return (
        <SocialMediaEmbedServerside>
          <FacebookEmbed url={content.attrs.url || ""} width={550} />
        </SocialMediaEmbedServerside>
      );
    case "linkedin":
      if (!checkIfValidLink(content.attrs.url)) {
        return null;
      }
      return (
        <SocialMediaEmbedServerside>
          <LinkedInEmbed
            url={content.attrs.url || ""}
            width={325}
            height={570}
          />
        </SocialMediaEmbedServerside>
      );
    case "insideLinks":
      return <InsideLinksComponent {...content} />;
    case "iframe":
      return (
        <SocialMediaEmbedServerside>
          <div className="iframe-wrapper">
            <iframe src={content?.attrs?.src ?? ""} allowFullScreen={true} />
          </div>
        </SocialMediaEmbedServerside>
      );
    default:
      return null;
  }
};
